/**
 * Misc storefront helpers:
 * - Opens chat when the URL contains ?open=chat (Zendesk custom launcher, zE API, or Reamaze)
 * - Adds a title to the Shopify theme preview bar iframe
 * - Marks decorative third-party SVG icons as aria-hidden
 */
(function () {
  // Open chat from ?open=chat URL parameter
  function openChatFromUrl() {
    // global.js updateURL() may already have removed ?open=chat, so also check the URL the page was loaded with
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var loadSearch = nav ? new URL(nav.name).search : '';
    if (new URLSearchParams(window.location.search).get('open') !== 'chat' &&
        new URLSearchParams(loadSearch).get('open') !== 'chat') return;

    var checkChat = setInterval(function () {
      // EU: custom Zendesk launcher
      var zendeskLauncher = document.querySelector('#desky-zendesk-custom-launcher');
      if (zendeskLauncher) {
        clearInterval(checkChat);
        setTimeout(function () {
          zendeskLauncher.click();
        }, 500);
        return;
      }

      // Zendesk Messaging / Classic Web Widget API
      if (typeof window.zE === 'function') {
        clearInterval(checkChat);
        setTimeout(function () {
          try {
            window.zE('messenger', 'open');
          } catch (e) {
            try {
              window.zE('webWidget', 'open');
            } catch (e2) {}
          }
        }, 500);
        return;
      }

      // AU fallback: Reamaze
      var chatWidget = document.querySelector('#reamaze-widget');
      if (chatWidget) {
        clearInterval(checkChat);
        setTimeout(function () {
          chatWidget.click();
        }, 500);
      }
    }, 200);
    setTimeout(function () {
      clearInterval(checkChat);
    }, 10000);
  }

  // Give the Shopify preview bar iframe an accessible title
  function setPreviewBarTitle() {
    function apply(frame) {
      if (!frame.title) {
        frame.title = 'Shopify theme preview bar';
      }
    }

    var frame = document.getElementById('PBarNextFrame');
    if (frame) {
      apply(frame);
      return;
    }

    var observer = new MutationObserver(function () {
      var previewFrame = document.getElementById('PBarNextFrame');
      if (previewFrame) {
        apply(previewFrame);
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Hide decorative third-party SVG icons from assistive tech
  function fixDecorativeSvgAccessibility(root) {
    (root || document)
      .querySelectorAll(
        '.gf-refine-toggle-mobile button svg, .gf-refine-toggle-mobile svg, .oke-reviewsSummary-icon > svg'
      )
      .forEach(function (icon) {
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        icon.setAttribute('role', 'presentation');
      });

    (root || document).querySelectorAll('.oke-reviewsSummary-icon').forEach(function (wrapper) {
      wrapper.setAttribute('aria-hidden', 'true');
    });
  }

  openChatFromUrl();
  setPreviewBarTitle();
  fixDecorativeSvgAccessibility();

  document.addEventListener('DOMContentLoaded', function () {
    fixDecorativeSvgAccessibility();
  });
  window.addEventListener('load', function () {
    fixDecorativeSvgAccessibility();
  });

  var svgObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        fixDecorativeSvgAccessibility(node);
      });
    });
  });
  svgObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
